import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSetAtom } from "jotai";

import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../../utils/GeneralUtils";
import { setSchemaAtom } from "../../../../atoms/GlobalAtoms";
import { newToastEvent } from "../../../../utils/ToastUtil";
import TenantAPI from "../../../api/TenantAPI";

// useMutation hook for modifying a modules field
const useModifyField = () => {
  const setSchema = useSetAtom(setSchemaAtom);
  const queryClient = useQueryClient();

  const modifyField = useMutation({
    mutationFn: ({
      moduleAPIName,
      fieldAPIName,
      fieldValues,
      supportTargetCloudID,
    }: {
      moduleAPIName: string;
      fieldAPIName: string;
      fieldValues: any;
      supportTargetCloudID: string | undefined;
      onSuccess?: () => void;
      onError?: (error: string) => void;
    }) => {
      return TenantAPI.editModuleField(
        moduleAPIName,
        fieldAPIName,
        fieldValues,
        supportTargetCloudID
      );
    },

    onSuccess: (data, { onSuccess, supportTargetCloudID }) => {
      const newSchema = data.data.data.schema;

      if (supportTargetCloudID) {
        queryClient.setQueryData(
          ["cloudSchema", supportTargetCloudID],
          newSchema
        );
      } else {
        setSchema(newSchema);
      }

      callFunctionIfExists(onSuccess, newSchema);
      newToastEvent("success", "Successfully modified field");
    },
    onError: (error, { onError }) => {
      const errorMsg = getErrorMessage(error);

      callFunctionIfExists(onError, errorMsg);
      newToastEvent("error", errorMsg);
    },
  });

  return {
    modifyField: modifyField.mutate,
    modifyingField: modifyField.isPending,
    modifyFieldError: modifyField.error
      ? getErrorMessage(modifyField.error)
      : null,
  };
};

export default useModifyField;
